import { Restaurant } from '../../API';

export const CORPORATE_LOCATION_NUM = '00000';
//contact submitted when an admin opens a ticket for the corporate location
export const ADMIN_CORPORATE_CONTACT_GUID = '3654239716276ffb5867050e0472a21b';

export const corpLocationData = {
  id: '',
  number: CORPORATE_LOCATION_NUM,
  name: 'CFA Corporate',
  supportDeskPhoneNumber: '',
  siteProperties: {
    lat: 0,
    long: 0,
    countryCode: '',
  },
  operator: {
    fullName: '',
    photoURL: '',
    email: '',
  },
  contacts: [
    {
      id: '',
      guid: '',
      fullName: '',
      firstName: '',
      lastName: '',
      audience: '',
      photoURL: '',
    },
  ],
};

export function getActiveLocationName(
  userLocations: Restaurant[],
  activeLocation: string
): string | undefined {
  return (
    userLocations.find(x => x.number === activeLocation)?.name || undefined
  );
}
